export const limit = globalThis?.innerWidth < 1737 && globalThis?.innerWidth > 1471 ? 25 : 24;
